import { ReactElement } from 'react';

import { beautifyPlanName } from '@localstack/services';
import { PlanFamily } from '@localstack/types';

import { ContentModal } from '../ContentModal';

type Props = {
  open: boolean;
  onClose: () => void;
  urlOpenerFunc: () => void;
  availablePlan: PlanFamily;
};

export const FeatureUnavailableDialog = ({ open, onClose, urlOpenerFunc, availablePlan }: Props): ReactElement => (
  <ContentModal
    dialogTitle="Unlock more services with a new plan"
    open={open}
    onClose={onClose}
    onConfirm={urlOpenerFunc}
    confirmButtonText={`Upgrade to ${beautifyPlanName(availablePlan)}`}
    modalMaxWidth="sm"
    dialogContent="This feature isn’t included in your current plan. Upgrade to unlock it."
  />
);
